import React from 'react';
import { Route, Routes } from 'react-router-dom';
import SectionTabs from '../components/SectionTabs';
import KeepQueryRedirect from '../components/KeepQueryRedirect';
import { SETTINGS_TABS } from '../utils/navMap';
import SettingsPage from './SettingsPage';
import UploadPage from './UploadPage';
import POSPage from './POSPage';

export default function SettingsSection() {
  return (
    <div>
      <SectionTabs label="Settings" tabs={SETTINGS_TABS} />
      <Routes>
        <Route path="account" element={<SettingsPage />} />
        <Route path="data" element={<UploadPage />} />
        <Route path="connections" element={<POSPage />} />
        {/* Stripe returns to /settings?payment=success — the query rides along to Account. */}
        <Route path="*" element={<KeepQueryRedirect to="/settings/account" />} />
      </Routes>
    </div>
  );
}
